import React from 'react';
//import $ from 'jquery';
import api from '../../../services/api';
import { Modal } from 'react-bootstrap';
import querystring from 'querystring';
import loadingGif from '../../../img/loading-gif.gif';

//conta ainda retornando HTML

class ContaForm extends React.Component {
	constructor(props) {
		super(props);

		this.resetForm = this.resetForm.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeInput = this.handleChangeInput.bind(this);
		this.setValidations();

		this.state = {
			nome: '',
			codigo: '',
			situacao: '',
			descricao: '',
			provedor: '',
			cnpj: '',
			cep: '',
		};

		if (this.props.item) {
			const item = this.props.item;
			this.state = {
				id: item.id,
				nome: item.nome,
				codigo: item.codigo,
				situacao: item.situacao,
				descricao: item.descricao,
				provedor: item.provedor,
				cnpj: item.cnpj,
				cep: item.cep,
			};
		}
	}

	componentDidUpdate(prevProps) {
		////console.log(this.props.item);
		////console.log(prevProps.item);

		/* const prevItem = {
			//id: this.state.id,
			nome: this.state.nome,
			codigo: this.state.codigo,
			situacao: this.state.situacao,
			descricao: this.state.descricao,
			provedor: this.state.provedor,
			cnpj: this.state.cnpj,
			cep: this.state.cep,
		};
    ////console.log(prevItem)*/

		if (this.props.item !== prevProps.item) {
			const item = this.props.item;
			////console.log(item);

			this.setState({
				id: item.id,
				nome: item.nome,
				codigo: item.codigo,
				situacao: item.situacao,
				descricao: item.descricao,
				provedor: item.provedor,
				cnpj: item.cnpj,
				cep: item.cep,
			});
		}
	}

	null2Empty(val) {
		if (val == null) return '';
		return val;
	}

	resetForm() {
		this.setState({
			id: '',
			nome: '',
			situacao: '',
			codigo: '',
			descricao: '',
			provedor: '',
			cnpj: '',
			cep: '',
		});
	}

	cancelForm() {
		if (this.props.item) {
			const item = this.props.item;
			////console.log(item);

			this.setState({
				id: item.id,
				nome: item.nome,
				codigo: item.codigo,
				situacao: item.situacao,
				descricao: item.descricao,
				provedor: item.provedor,
				cnpj: item.cnpj,
				cep: item.cep,
			});
		} else {
			this.resetForm();
		}
	}

	handleChangeInput(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value,
		});
	}

	showErrorMessage(key) {
		if (!this.validations[key] || this.validations[key].valid !== false) return;
		return this.validations[key].message;
	}

	handleSubmit(e, setModalVisible) {
		const self = this;
		e.preventDefault();
		if (!this.validate()) {
			this.forceUpdate();
			return;
		}

		////console.log('contas', this.state);

		const qsData = querystring.stringify(this.state);

		this.setState({ loading: true });
		const options = {
			//method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			//data: x,
			//url: '/admin/unidade',
		};

		api.post('/admin/conta', qsData,options).then(({ data, status }) => {
			////console.log(data)
			if (data === false) {
				alert('Solicitação inválida');
				this.setState({
					loading: false,
				});
				return;
			}

			if (data.errors) {
				var keys = Object.keys(data.errors);
				var msgs = '';
				for (var i = 0; i < keys.length; i++) {
					msgs += data.errors[keys[i]] + '\n';
				}
				this.setState({
					loading: false,
				});
				alert(msgs);
				return;
			}

			if (status === 200 && data.id) {
				if (!self.state.id) {
					//$('#' + self.props.elementId + 'Elem')[0].reset();
				}

				if (typeof self.props.callback == 'function') {
					self.props.callback(data);
					this.setState({
						loading: false,
					});
				}

				//$('#' + self.props.elementId).modal('hide');
			}
			setModalVisible(false);
		});
	}

	validate() {
		var valid = true;
		var keys = Object.keys(this.validations);

		for (var i = 0; i < keys.length; i++) {
			this.validations[keys[i]].valid = this.validations[keys[i]].validator(
				this.state[keys[i]]
			);
			if (!this.validations[keys[i]].valid) {
				valid = false;
				continue;
			}
		}

		return valid;
	}

	setValidations() {
		this.validations = {
			nome: {
				valid: null,
				message: 'nome inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			codigo: {
				valid: null,
				message: 'codigo inválida',
				validator: (value) => {
					////console.log('codigo', value);
					return Boolean(value && String(value).length > 0);
				},
			},
			situacao: {
				valid: null,
				message: 'situação inválido',
				validator: (value) => {
					return ['0', '1'].indexOf(String(value)) > -1;
				},
			},
			descricao: {
				valid: null,
				message: 'descrição inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			cnpj: {
				valid: null,
				message: 'CNPJ inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			cep: {
				valid: null,
				message: 'CEP inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
		};
	}

	render() {
		const props = this.props;
		const conta = this.state;
		const { modalVisible, setModalVisible } = props;

		return (
			<Modal
				show={modalVisible}
				onHide={() => {
					setModalVisible(false);
				}}>
				<Modal.Header>
					<h2 className='modal-title'>
						{props.item ? 'Editar Conta' : 'Nova Conta'}
					</h2>
				</Modal.Header>
				<Modal.Body>
					<form
						id={props.elementId + 'Elem'}
						onSubmit={(e) => {
							this.handleSubmit(e, setModalVisible);
						}}>
						<div className='modal-body'>
							<div className='form-group'>
								<label>Nome</label>
								<input
									className='form-control'
									type='text'
									name='nome'
									value={conta.nome}
									onChange={this.handleChangeInput}
								/>
								<span className='text-danger'>
									{this.showErrorMessage('nome')}
								</span>
							</div>
							<div className='form-group'>
								<label>Código Stone</label>
								<input
									className='form-control'
									type='text'
									name='codigo'
									value={conta.codigo}
									onChange={this.handleChangeInput}
								/>
								<span className='text-danger'>
									{this.showErrorMessage('codigo')}
								</span>
							</div>
							<div className='form-group'>
								<label>Situação</label>
								<select
									className='form-control'
									name='situacao'
									value={conta.situacao}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									<option value='1'>Ativada</option>
									<option value='0'>Desativada</option>
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('situacao')}
								</span>
							</div>
							<div className='form-group'>
								<label>Descrição</label>
								<textarea
									className='form-control'
									name='descricao'
									value={conta.descricao}
									onChange={this.handleChangeInput}></textarea>
								<span className='text-danger'>
									{this.showErrorMessage('descricao')}
								</span>
							</div>
							<div className='form-group'>
								<label>Provedor</label>
								<select
									className='form-control'
									name='provedor'
									value={conta.provedor}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									<option value='STONE'>Stone</option>
									<option value='MUNDIPAGG'>Mundipagg</option>
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('provedor')}
								</span>
							</div>
							<div className='form-group'>
								<label>CNPJ</label>
								<input
									type='text'
									className='form-control'
									name='cnpj'
									value={conta.cnpj}
									onChange={this.handleChangeInput}
								/>
								<span className='text-danger'>
									{this.showErrorMessage('cnpj')}
								</span>
							</div>
							<div className='form-group'>
								<label>CEP</label>
								<input
									type='text'
									className='form-control'
									name='cep'
									value={conta.cep}
									onChange={this.handleChangeInput}
								/>
								<span className='text-danger'>
									{this.showErrorMessage('cep')}
								</span>
							</div>
						</div>
						<div className='modal-footer'>
							<button
								type='button'
								onClick={(e) => {
									e.preventDefault();
									//this.resetForm();
									this.cancelForm();

									setModalVisible(false);
								}}
								className='btn btn-light border'
								data-dismiss='modal'>
								Cancelar
							</button>
							<button type='submit' className='btn btn-primary'>
								{conta.loading ? (
									<img className='loadingImg' src={loadingGif} alt='loading' />
								) : (
									'Salvar'
								)}
							</button>
						</div>
					</form>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
		);
	}
}

export default ContaForm;
